module.exports = __webpack_public_path__ + "2b1832884a864ab9d8c1f2f6ebf72701.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Dolphin1.jpg
// module id = 3461
// module chunks = 0